import React, {FC} from 'react';
import styled, {css, CSSObject} from 'styled-components';
import useMediaQuery from '../../hooks/useMediaQuery';

type StyledTextProps = {
  customStyles?: React.CSSProperties;
  hoverStyles?: React.CSSProperties;
};

const StyledText = styled.div<StyledTextProps>`
  font-family: var(--font-family-text, vw-text);
  ${(props) => props.customStyles && css(props.customStyles as CSSObject)};
  &:hover {
    ${(props) => props.hoverStyles && css(props.hoverStyles as CSSObject)};
  }
`;
type Size = 'small' | 'medium' | 'large' | 'body';

const fontSizeMap: Record<Size, number> = {
  large: 48,
  medium: 32,
  body: 20,
  small: 16,
};

const fontSizeMapMobile: Record<Size, number> = {
  large: 24,
  medium: 20,
  body: 16,
  small: 14,
};

interface Props {
  size?: Size;
  bold?: boolean;
  color?: React.CSSProperties['color'];
  children: React.ReactNode;
  style?: React.CSSProperties;
  textAlign?: React.CSSProperties['textAlign'];
  onClick?: () => void;
  hoverStyles?: React.CSSProperties;
  className?: string;
}

const TypographyBody: FC<Props> = (props) => {
  const {
    size = 'medium',
    bold,
    children,
    style = {},
    color = '#fff',
    textAlign = 'left',
    onClick,
    hoverStyles,
    className,
  } = props;

  const {isMobile} = useMediaQuery();
  return (
    <StyledText
      customStyles={{
        lineHeight: '110%',
        fontWeight: bold ? '700' : '300',
        fontSize: isMobile ? fontSizeMapMobile[size] : fontSizeMap[size],
        color,
        textAlign,
        ...style,
      }}
      hoverStyles={{
        ...hoverStyles,
      }}
      onClick={onClick}
      className={className}
    >
      {children}
    </StyledText>
  );
};

export default TypographyBody;
